(function () {

  'use strict';

  angular
    .module('services.risparmioBuoni', ['ngResource'])
    .factory(
      'RisparmioBuoniServices',
      ['$resource', '$filter', RisparmioBuoniServicesController]
    );

  angular
    .module('services.uikitProxy', [])
    .factory('UikitProxy',
      [function () {

        function applyDatepicker(
          groupId,
          options = { startDate: undefined, endDate: undefined }
        ) {

          options = Object.assign({
            language: "it",
            orientation: "bottom auto",
            autoclose: true,
            todayHighlight: true
          }, options);

          setTimeout(() => {
            $(`#${groupId}`).datepicker(options);
          })
        };

        function slick(className, options = {}) {
          className = `.${className}`;

          setTimeout(() => {

            if ($(className).hasClass('slick-initialized')) {
              return;
            };

            options = Object.assign(options, {
              regionLabel: 'lorem ipsum sed nunc facilis aria label banner alfa',
              slidesToShow: 2,
              slidesToScroll: 1,
              adaptiveHeight: true,
              variableWidth: false,
              responsive: [{
                breakpoint: 768,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  dots: true,
                  arrows: true,
                }
              }],
            });

            $(className).slick(options);
          })
        }

        function repositionFloatLabel() {
          /*****************************************/
          /* Gestione Form  */
          /*****************************************/
          focusLabelTransition(); // Intercetta il focus per gestire l'animazione delle label
          labelrePosition();      // Riposizionamento label su campi Input-group 
          focusInputGroup();      // Gestione colore focus sugli elementi input-group addon dei campi Input-group
        }

        return {
          repositionFloatLabel,
          applyDatepicker,
          slick
        }

      }])


  angular
    .module('risparmioBuoni')
    .component('risparmioBuoni', {
      templateUrl: '/widgets/rpol/calcolatore/views/risparmio-buoni.template.html',
      controller: [
        '$sce',
        '$log',
        '$timeout',
        'RisparmioBuoniServices',
        'UikitProxy',
        RisparmioBuoniController
      ],
      bindings: {}
    });


  function RisparmioBuoniController($sce, $log, $timeout, RisparmioBuoniServices, UikitProxy) {

    var vm = this;

    // TODO
    vm.field_errors = {};

    vm.note = [];

    vm.premialeActive = true;

    vm.primoCalcolo = false;
    vm.tassoScadenza = 0;
    vm.premioNetto = 0;
    vm.buonoPremioSelected = false;
    

    let _buonoPremioSelected = vm.buonoPremioSelected;
    Object.defineProperty(vm, 'buonoPremioSelected', {
      get: function () {
        return _buonoPremioSelected;
      },
      set: function (value) {
        if (_buonoPremioSelected !== value) {
          _buonoPremioSelected = value;
        } else {
          _buonoPremioSelected = value;
        }
      }
    });

    let _tassoScadenza = vm.tassoScadenza;
    Object.defineProperty(vm, 'tassoScadenza', {
      get: function () {
        return _tassoScadenza;
      },
      set: function (value) {
        if (_tassoScadenza !== value) {
          _tassoScadenza = value;
        } else {
          _tassoScadenza = value;
        }
      }
    });

    let _premioNetto = vm.premioNetto;
    Object.defineProperty(vm, 'premioNetto', {
      get: function () {
        return _premioNetto;
      },
      set: function (value) {
        if (_premioNetto !== value) {
          _premioNetto = value;
        } else {
          _premioNetto = value;
        }
      }
    });

    let _tipologia = vm.tipologia;
    Object.defineProperty(vm, 'tipologia', {
      get: function () {
        return _tipologia;
      },
      set: function (value) {
        if (_tipologia !== value) {
          _tipologia = value;
          if (vm.primoCalcolo) {
            vm.show_calcolo_buono = false;
          }
        } else {
          _tipologia = value;
        }
      }
    });

    /** ********************************************************************* */
    /** CONFIGURAZIONI ****************************************************** */
    /** ********************************************************************* */
    /**
     * on Init
     */
    vm.$onInit = function () {
      // initialize variables
      if (reset()) {

      }

      UikitProxy.applyDatepicker('campo-calendar3-group', { endDate: new Date() });
      setTimeout(UikitProxy.repositionFloatLabel);
    };


    vm.$postLink = function () {

      window.addEventListener('resize', equalize_card);

      let timer;

      function equalize_card() {
        if (timer) clearTimeout(timer);
        timer = setTimeout(() => {
          equalize('.buono-card');
          equalize('.panel-cards-comparison');
        }, 10);
      }

      // check per query param calcolo diretto:
      vm.autoSimula();
    }


    vm.onclick = function (event) {
      const target = event.target;
      const method = target && target.attributes && target.attributes.method && target.attributes.method.value;
      const value = target && target.attributes && target.attributes.param && target.attributes.param.value;

      if (vm.hasOwnProperty(method)) {
        vm[method](value);
      }
    }

    /*Funzionalità per verificare la presenza di parametro per autosimulazione da link esterno e in caso attivazione del giro*/
    vm.autoSimula = function () {

      var wQuery = window.location.search.substring(1);
      if (!wQuery || wQuery == "")
        return;

      var wQp = wQuery.split("&");

      var b64Json = {};

      for (var i = 0; i < wQp.length; i++) {
        var pair = wQp[i].split("=");

        if (pair[0] == 'sab') {
          try {
            b64Json = JSON.parse(atob(decodeURIComponent(pair[1])));
            // console.log(b64Json);
          }
          catch (e) {
            console.error(e);
            return;
          }
        }
      }


      // check & set dei model necessari

      // check date

      var dataSotto = new Date(b64Json.datasottoscrizione);
      var dataRimb = new Date(b64Json.datarimoborsosottoscrizione);
      var imp = "";

      if (!dataSotto || isNaN(dataSotto.valueOf()) ||
        !dataRimb || isNaN(dataRimb.valueOf())) {
        vm.serviceerrorsottoscrizione_message = "Errore in fase di compilazione: date non corrette.";
        vm.show_serviceerrorsottoscrizione = true;
        // go_to("#service_error_sottoscrizione");
        //console.log("errore date");
        return;
      }

      if (!b64Json.importo || isNaN(b64Json.importo)) {
        vm.serviceerrorsottoscrizione_message = "Errore in fase di compilazione: importo non corretto.";
        vm.show_serviceerrorsottoscrizione = true;
        // go_to("#service_error_sottoscrizione");
        //console.log("errore date");
        return;
      }
      else {
        imp = b64Json.importo.toString();
      }


      if (Object.keys(vm.divisa_options).indexOf(b64Json.divisa) < 0) {
        vm.serviceerrorsottoscrizione_message = "Errore in fase di compilazione: divisa non corretta.";
        vm.show_serviceerrorsottoscrizione = true;
        // go_to("#service_error_sottoscrizione");
        //console.log("errore date");
        return;
      }



      var datasottoscrizioneIt = ('0' + dataSotto.getDate()).slice(-2) + "/" + ('0' + (dataSotto.getMonth() + 1)).slice(-2) + "/" + dataSotto.getFullYear();
      var datarimoborsosottoscrizioneIt = ('0' + dataRimb.getDate()).slice(-2) + "/" + ('0' + (dataRimb.getMonth() + 1)).slice(-2) + "/" + dataRimb.getFullYear();

      setTimeout(function () {

        vm.datasottoscrizione = datasottoscrizioneIt;
        vm.datarimoborsosottoscrizione = datarimoborsosottoscrizioneIt;
        vm.tipologia = b64Json.tipologia;
        vm.importosottoscrizione = imp.substr(0, imp.length - 2);
        vm.importosottoscrizionedecimali = imp.substr(imp.length - 2);
        vm.divisa = b64Json.divisa;

        // $('#campo-calendar3').datepicker("setValue", vm.datasottoscrizione);

        vm.calcolaAuto();

      }, 100)

    }



    vm.calcolaAuto = function () {

      // show_pageloader();
      vm.calcola_disabled = true;

      // call catalogo BFP BE
      RisparmioBuoniServices.catalogoBfp({
        data: {
          dataSottoscrizione: italian_date(vm.datasottoscrizione)
        }
      }, catalogoBfpOKAuto, catalogoBfpKOAuto);

    }

    /**
     * catalogo BFP service OK
     */
    function catalogoBfpOKAuto(httpResponse) {
      $log.log('ManagerController catalogoBfp response:', httpResponse);

      // get BE data
      var data = httpResponse.data || {};
      if (data.listaBfp) {
        vm.tipologie_options = data.listaBfp;
      }


      //check tipologia valida
      if (vm.tipologie_options.filter(function (e) { return e.tipoBuono == vm.tipologia }).length < 1) {
        vm.serviceerrorsottoscrizione_message = "Errore in fase di compilazione: tipologia buono non corretta.";
        vm.show_serviceerrorsottoscrizione = true;
        // go_to("#service_error_sottoscrizione");
        //console.log("errore date");
        return;
      }

      // clean UI
      /*make_calendar("#calendar-sottoscrizionerimborso", {
        startDate: get_currentDate()
      });*/

      vm.calcola_disabled = false;
      vm.sottoscrizione_disabled = false;

      vm.show_calcola = true;
      setTimeout(UikitProxy.repositionFloatLabel)
      // make_popovers();
      // setTimeout(customSelect, 100);
      // setTimeout(function () {
      //   $('#campo-calendar4').datepicker("setValue", vm.datarimoborsosottoscrizione);
      //   vm.calcolasottoscrizioneAuto();
      // }, 100);
      // hide_pageloader();

    }

    /**
     * catalogo BFP service KO
     */
    function catalogoBfpKOAuto(httpResponse) {
      $log.log('ManagerController catalogoBfp error-response:', httpResponse);

      if (httpResponse.data && httpResponse.data.metadata) {
        vm.serviceerrorsottoscrizione_message = httpResponse.data.metadata.message;
      } else {
        vm.serviceerrorsottoscrizione_message = "Il servizio è momentaneamente sospeso. Ci scusiamo per il disagio arrecato."
      }

      // show error boxes
      vm.show_serviceerrorsottoscrizione = true;
      vm.show_calcola = false;
      // hide_pageloader();
    }


    /** ********************************************************************* */
    /** TROVA IL BUONO ****************************************************** */
    /** ********************************************************************* */

    /**
     * disabilita i tasti confronta
     */
    vm.disable_counter = function (id) {
      var found = 0;
      for (var i = 0; i < vm.buoni_selected.length; i++) {
        if (vm.buoni_selected[i].BuonoID == id) {
          return false;
        }
      }
      return vm.buoni_selected.length > 1 || false;
    }

    /**
     * mostra e recupera valore del counter
     */
    vm.get_counter = function (id) {
      var found = 0;
      for (var i = 0; i < vm.buoni_selected.length; i++) {
        if (vm.buoni_selected[i].BuonoID == id) {
          found = i + 1;
        }
      }
      return found;
    }

    /**
     * seleziona buono (max 2)
     */
    vm.seleziona = function (id) {

      // search BFP by id
      // -> if found, deselect it
      // -> if not found, select it
      var found = false;
      for (var i = 0; i < vm.buoni_selected.length; i++) {
        if (vm.buoni_selected[i].BuonoID == id) {
          found = true;
          vm.buoni_selected.splice(i, 1);
        }
      }
      if (!found) {
        if (vm.buoni_selected.length < 2) {
          vm.buoni_selected.push(vm.lista_buoni[id]);
        }
      }
      vm.buonoPremioSelected = vm.buoni_selected.some(buono => buono.isPremiale);

      // make slick slider
      // make_slick_slider('#simulatore01', '#simulatore_faked');
      // UikitProxy.slick('slick-buoni')


      setTimeout(() => {
        const buoni_selected = document.querySelector('#buoni_selected');

        Array.from(buoni_selected.children).forEach((item, index) => {
          const slick = document.querySelector(`#slick-${index}`);
          slick.innerHTML = item.innerHTML;
        });
      });

      // show rimborso area and make graphs
      if (vm.buoni_selected.length > 0) {

        // make graphs
        for (var j = 0; j < vm.buoni_selected.length; j++) {

          id = vm.buoni_selected[j].BuonoID;
          let labels = [];

          if( !vm.riceviCedole ) {
            var min = vm.importo;
            // add data to graph
            var max = 0;
            var datasets = [{
              borderWidth: 3,
              backgroundColor: '#cccccc',
              borderColor: 'rgba(46, 108, 227, 1)',
              lineTension: 0,
              steppedLine: true,
              data: []
            }];
            for (var i = 0; i < vm.lista_buoni[id].rendimenti.length; i++) {
              var value = vm.lista_buoni[id].rendimenti[i].importoNetto / 100;
              if (i == vm.lista_buoni[id].rendimenti.length - 1) {
                max = value;
              }
              datasets[0].data.push(value);
            }
            
            for (var i = 0; i < vm.lista_buoni[id].rendimenti.length; i++) {
              if (i == vm.lista_buoni[id].rendimenti.length - 1) {
                labels.push(vm.lista_buoni[id].durata);
              } else {
                labels.push(vm.lista_buoni[id].rendimenti[i].anno
                  + " ann"
                  + decline(vm.lista_buoni[id].rendimenti[i].anno,
                    "o", "i")
                  + " "
                  + vm.lista_buoni[id].rendimenti[i].mese
                  + " mes"
                  + decline(vm.lista_buoni[id].rendimenti[i].mese,
                    "e", "i"));
              }

            }
            make_graph('canvas-bfp-' + id, 'line', {
              labels: labels,
              datasets: datasets
            }, true, min, max);

          } else {
            var datasets = [{
              barPercentage: 1.0,
              categoryPercentage: 0.3,
              backgroundColor: 'rgba(46, 108, 227, 1)',
              data: []
            }];

            for (var i = 0; i < vm.lista_buoni[id].rendimenti.length; i++) {
              var value = vm.lista_buoni[id].rendimenti[i].valoreNettoCedolaProg / 100;
              if (i == vm.lista_buoni[id].rendimenti.length - 1) {
                max = value;
              }
              datasets[0].data.push(value);
            }
            for (var i = 0; i < vm.lista_buoni[id].rendimenti.length; i++) {
              // if (i == vm.lista_buoni[id].rendimenti.length - 1) {
              //   labels.push(formatItalianDateString(vm.lista_buoni[id].rendimenti[i].dataMaturazione));
              // } 
              // else {
              // }
              labels.push(formatItalianDateString(vm.lista_buoni[id].rendimenti[i].dataMaturazione));
            }

            make_graph('canvas-bfp-' + id, 'bar', {
              labels: labels,
              datasets: datasets
            }, true, 0, max);
          }
        }

        // make calendar and show rimborso area
        vm.show_rimborso = true;
        vm.show_rimborsograph = false;
        vm.show_serviceerrorrimborso = false;
        vm.datarimborso = null;
        vm.preparecalcolarimborso();
        // make_calendar('#calendar-rimborso', {
        //   startDate: get_currentDate()
        // });

        // pari_altezza('.equalize-group-2 .panel-cards', true);
        // pari_altezza('.equalize-group-2 .note', true);
        const date = new Date();
        date.setDate(date.getDate());
        UikitProxy.applyDatepicker('campo-calendar1-group', { startDate: date });

      } else {
        vm.show_rimborso = false;
      }

      // clean UI
      $(window).resize();

      $timeout(() => {
        equalize('.panel-cards-comparison');
      })

    }

    /**
     * download progressioni
     */
    vm.downloadProgressioni = function (id) {
      // show_pageloader();

      if(vm.riceviCedole){
        RisparmioBuoniServices.downloadDataCedola({
          data: {
            "importo": "" + parseInt(vm.importo) * 100,
            "codProd": id,
            "divisa": "EUR",
            "from": "SIMULA"
          }
        }, downloadOK, downloadKO);

      } else {
        RisparmioBuoniServices.downloadData({
          data: {
            "importo": "" + parseInt(vm.importo) * 100,
            "codProd": id,
            "divisa": "EUR",
            "from": "SIMULA"
          }
        }, downloadOK, downloadKO);
      }

      // call BE
    }

    /**
     * download progressioni (valore)
     */
    vm.downloadProgressioniValore = function (e, pdf) {
      vm.preventDefault(e, true);

      // show_pageloader();

      // call BE
      var params = {
        data: {
          "importo": ""
            + parseInt(vm.importosottoscrizione
              + ","
              + vm.importosottoscrizionedecimali)
            * 100,
          "codProd": "" + vm.tipologia,
          "divisa": vm.divisa,
          "from": "CALCOLA",
          "dataSottoscrizione": italian_date(vm.datasottoscrizione),
          "dataNascita": italian_date(vm.datarimoborsosottoscrizioneminore)
        }
      };
      if (pdf) {
        RisparmioBuoniServices.downloadDataPdf(params, downloadOK, downloadKOValore);
      } else {
        if(vm.valorebuono.isCedola === true){
          RisparmioBuoniServices.downloadDataCedola(params, downloadOK, downloadKOValore);
        } else {
          RisparmioBuoniServices.downloadData(params, downloadOK, downloadKOValore);
        }
      }
    }

    /**
     * download data service OK
     */
    function downloadOK(httpResponse) {
      $log.log('ManagerController download response:', httpResponse);

      // download file
      if (httpResponse.data) {
        var ab = base64ToArrayBuffer(httpResponse.data.content);
        download_file(new Blob([ab], {
          type: httpResponse.data.contentType
        }), httpResponse.data.title);
      }

      vm.show_serviceerror = false;
      // hide_pageloader();
    }

    /**
     * download data service KO
     */
    function downloadKO(httpResponse) {
      $log.log('ManagerController download error-response:', httpResponse);

      if (httpResponse.data && httpResponse.data.metadata) {
        vm.serviceerror_message = httpResponse.data.metadata.message;
      } else {
        vm.serviceerror_message = "Si è verificato un errore. Ci scusiamo per il disagio arrecato."
      }

      // show error box
      vm.show_serviceerror = true;
      // hide_pageloader();
      // go_to("#service_error");
    }

    /**
     * download data service KO
     */
    function downloadKOValore(httpResponse) {
      $log.log('ManagerController download error-response:', httpResponse);

      if (httpResponse.data && httpResponse.data.metadata) {
        vm.serviceerrorsottoscrizione_message = httpResponse.data.metadata.message;
      } else {
        vm.serviceerrorsottoscrizione_message = "Si è verificato un errore. Ci scusiamo per il disagio arrecato."
      }

      // show error box
      vm.show_serviceerrorsottoscrizione = true;
      // hide_pageloader();
      // go_to("#service_error_sottoscrizione");
    }

    /** ********************************************************************* */
    /** CALCOLA RIMBORSO **************************************************** */
    /** ********************************************************************* */

    /**
     * prepare calcola rimborso
     */
    vm.preparecalcolarimborso = function () {
      var selected = get_date(vm.datarimborso);
      vm.disable_calcolarimborso = (!vm.datarimborso || !selected
        || isNaN(selected) || selected.valueOf() < get_currentDate()) || false;
    }

    /**
     * calcola rimborso
     */
    vm.calcolarimborso = function () {
      // show_pageloader();

      var listaBfp = [];
      for (var i = 0; i < vm.buoni_selected.length; i++) {
        listaBfp.push(vm.buoni_selected[i].codProdotto);
      }

      // call BE
      RisparmioBuoniServices.calcolaRimborso({
        data: {
          dataRimborso: italian_date(vm.datarimborso),
          listaBfp: listaBfp,
          importo: "" + parseInt(vm.importo) * 100
        }
      }, calcolarimborsoOK, calcolarimborsoKO);
    }

    /**
     * calcola rimborso OK
     */
    function calcolarimborsoOK(httpResponse) {
      $log.log('ManagerController calcolarimborso response:', httpResponse);

      // add data to rimborso graph
      var data = httpResponse.data || [];
      if (data.length > 0) {

        // note
        vm.noterimborso = [];
        for (var i = 0; i < data.length; i++) {
          for (var j = 0; j < data[i].listaNoteCalcolatoreBfp.length; j++) {
            vm.noterimborso
              .push(data[i].listaNoteCalcolatoreBfp[j].messaggio);
          }
        }

        var datasets = [{
          barPercentage: 1.0,
          categoryPercentage: 0.8,
          backgroundColor: 'rgba(46, 108, 227, 1)',
          data: []
        }];
        for (var i = 0; i < data.length; i++) {
          datasets[0].data.push(data[i].valoreNetto / 100);
        }
        var labels = [];
        for (var i = 0; i < data.length; i++) {
          labels.push(vm.lista_buoni[data[i].codProd].nomeProdotto);
        }

        // make graph
        make_graph('canvas-rimborso', 'bar', {
          labels: labels,
          datasets: datasets
        });

      }

      // show results
      vm.show_serviceerrorrimborso = false;
      vm.show_rimborsograph = true;
      // hide_pageloader();
      // go_to("#rimborso_buono");
    }

    /**
     * calcola rimborso KO
     */
    function calcolarimborsoKO(httpResponse) {
      $log.log('ManagerController calcolarimborso error-response:',
        httpResponse);

      if (httpResponse.data && httpResponse.data.metadata) {
        vm.serviceerrorrimborso_message = httpResponse.data.metadata.message;
      } else {
        vm.serviceerrorrimborso_message = "Si è verificato un errore. Ci scusiamo per il disagio arrecato.";
      }

      // destroy the canvas
      if (window["my_canvas-rimborso"]) {
        window["my_canvas-rimborso"].destroy();
      }

      // show error box
      vm.show_serviceerrorrimborso = true;
      vm.show_rimborsograph = false;
      // hide_pageloader();
      // go_to("#service_error_rimborso");
    }

    /** ********************************************************************* */
    /** BUONO SENIOR ******************************************************** */
    /** ********************************************************************* */

    /**
     * prepare search senior
     */
    var delayTimerSenior;
    vm.preparesearchsenior_d = function () {
      $timeout.cancel(delayTimerSenior);
      delayTimerSenior = $timeout(vm.preparesearchsenior, 500);
    }

    vm.preparesearchsenior = function () {
      var importo = parseInt(vm.importosenior);
      vm.show_boxerrorsenior = vm.show_importoerrorsenior = (isNaN(vm.importosenior)
        || importo == 0 || importo % 50 || importo > 1000000) || false;
      var selected = get_date(vm.datanascitasenior);
      vm.disable_calcolosenior = (isNaN(vm.importosenior) || !importo
        || importo == 0 || !vm.datanascitasenior || !selected
        || isNaN(selected) || selected.valueOf() > Date.now()) || false;
    }

    /**
     * search senior
     */
    vm.searchsenior = function () {
      // show_pageloader();

      // call BE
      RisparmioBuoniServices.buonosenior({
        data: {
          importo: "" + parseInt(vm.importosenior) * 100,
          dataNascita: italian_date(vm.datanascitasenior)
        }
      }, searchseniorOK, searchseniorKO);
    }

    /**
     * buono senior service OK
     */
    function searchseniorOK(httpResponse) {
      $log.log('ManagerController buonosenior response:', httpResponse);

      // add BE data to BFP minori
      vm.buono_senior = [];
      var data = httpResponse.data || {};
      if (data.tipoBuono && vm.lista_buoni[data.tipoBuono] != null) {
        vm.lista_buoni[data.tipoBuono] = Object.assign(
          vm.lista_buoni[data.tipoBuono], data);
        vm.buono_senior.push(vm.lista_buoni[data.tipoBuono]);
      }

      // show result
      vm.show_serviceerrorsenior = false;
      vm.show_senior = true;
      vm.show_notesenior = true;
      // hide_pageloader();
      // go_to("#buono_senior");
    }

    /**
     * buono senior service KO
     */
    function searchseniorKO(httpResponse) {
      $log.log('ManagerController buonosenior error-response:', httpResponse);

      if (httpResponse.data && httpResponse.data.metadata) {
        vm.serviceerrorsenior_message = httpResponse.data.metadata.message;
      } else {
        vm.serviceerrorsenior_message = "Si è verificato un errore. Ci scusiamo per il disagio arrecato."
      }

      // show error box
      vm.show_serviceerrorsenior = true;
      vm.show_senior = false;
      vm.show_notesenior = false;
      // hide_pageloader();
      // go_to("#service_error_senior");
    }

    /** ********************************************************************* */
    /** CALCOLO SOTTOSCRIZIONE ********************************************** */
    /** ********************************************************************* */

    vm.parse_date = (date) => {
      date = date.toLocaleDateString('it-IT');
      date = date.split('/').reverse().join('-');
      return date;
    }

    /**
     * prepara calcola
     */
    vm.preparecalcola = function () {
      var selected = get_date(vm.datasottoscrizione);

      if (selected) {
        var is_future_date = selected.valueOf() > Date.now()
        vm.calcola_disabled = (
          !vm.datasottoscrizione
          || !selected
          || isNaN(selected)
          || is_future_date
        ) || false;

        // show warning for USER
        this.field_errors.datasottoscrizione = is_future_date
          ? 'La data inserita è superiore a quella odierna'
          : '';

        var s = selected.toJSON();
        if (s) {
          s = s.slice(0, 10);
          if (s < "1999-01-01") {
            vm.divisa = vm.divisa_options.ITL.value;
            vm.divisa_disabled = false;
          } else if (s > "2002-04-30") {
            vm.divisa = vm.divisa_options.EUR.value;
            vm.divisa_disabled = true;
          } else {
            vm.divisa = vm.divisa_options.EUR.value;
            vm.divisa_disabled = false;
          }
          // $timeout(customSelect);
        }
      }
      vm.show_calcola = false;
      vm.tipologia = null;
      vm.tipologie_options = null;
      vm.datarimoborsosottoscrizione = null;
      vm.datarimoborsosottoscrizioneminore = null;
      vm.importosottoscrizione = null;
      vm.importosottoscrizionedecimali = "00";
      vm.show_serviceerrorsottoscrizione = false;
      vm.show_calcolo_buono = false;
      vm.show_notevalore = false;
      vm.preparecalcolasottoscrizione();
    }

    /**
     * calcola
     */
    vm.calcola = function () {
      vm.calcola_disabled = true;

      // call catalogo BFP BE
      RisparmioBuoniServices.catalogoBfp({
        data: {
          dataSottoscrizione: italian_date(vm.datasottoscrizione)
        }
      }, catalogoBfpOK, catalogoBfpKO);

    }

    /**
     * catalogo BFP service OK
     */
    function catalogoBfpOK(httpResponse) {
      $log.log('ManagerController catalogoBfp response:', httpResponse);

      // get BE data
      var data = httpResponse.data || {};
      if (data.listaBfp) {
        vm.tipologie_options = data.listaBfp;
      }

      // clean UI
      /* make_calendar("#calendar-sottoscrizionerimborso", {
        startDate: get_currentDate()
      });
      make_calendar("#calendar-sottoscrizionerimborsominore", {
        endDate: Date.now()
      });
      */
      vm.show_calcola = true;
      setTimeout(UikitProxy.repositionFloatLabel)


      const date = new Date();
      date.setDate(date.getDate());
      UikitProxy.applyDatepicker('campo-calendar4-group', { startDate: date });
      UikitProxy.applyDatepicker('campo-calendar5-group');
      // make_popovers();
      // hide_pageloader();
    }

    /**
     * catalogo BFP service KO
     */
    function catalogoBfpKO(httpResponse) {
      $log.log('ManagerController catalogoBfp error-response:', httpResponse);

      if (httpResponse.data && httpResponse.data.metadata) {
        vm.serviceerrorsottoscrizione_message = httpResponse.data.metadata.message;
      } else {
        vm.serviceerrorsottoscrizione_message = "Il servizio è momentaneamente sospeso. Ci scusiamo per il disagio arrecato."
      }

      // show error boxes
      vm.show_serviceerrorsottoscrizione = true;
      vm.show_calcola = false;
    }

    /**
     * prepare calcola sottoscrizione
     */
    vm.preparecalcolasottoscrizione = function () {
      var importo = parseInt(vm.importosottoscrizione);
      var selected_r = get_date(vm.datarimoborsosottoscrizione);
      var selected_m = get_date(vm.datarimoborsosottoscrizioneminore);
      vm.sottoscrizione_disabled = (isNaN(vm.importosottoscrizione)
        || isNaN(vm.importosottoscrizionedecimali) || !importo
        || importo == 0 || vm.divisa == null
        || !vm.datasottoscrizione
        || !vm.datarimoborsosottoscrizione || !selected_r
        || isNaN(selected_r)
        || selected_r.valueOf() < get_currentDate() || !vm.tipologia || (vm.tipologia == 'M' && (!vm.datarimoborsosottoscrizioneminore
          || !selected_m || isNaN(selected_m) || selected_m.valueOf() > Date
            .now()))) || false;
    }

    /**
     * calcola sottoscrizione
     */
    vm.calcolasottoscrizione = function () {

      // max 3 try
      set_try_calcolo();
      if (vm.activate_cookie_calcolo && vm.try_calcolo > 3) {
        vm.show_max_calcolo = true;
        vm.show_calcolo_buono = false;
        // go_to("#max_tentativi");
        return;
      }
      vm.primoCalcolo = true;
      /*if(vm.tipologia === '28'){
        //calcola valore buoni a cedola
          RisparmioBuoniServices
          .calcolaValoreBfpCedole(
            {
              data: {
                dataEmissione: italian_date(vm.datasottoscrizione),
                dataRimborso: italian_date(vm.datarimoborsosottoscrizione),
                dataNascita: italian_date(vm.datarimoborsosottoscrizioneminore),
                tipoBuono: vm.tipologia,
                taglio: ""
                  + parseInt(vm.importosottoscrizione
                    + ","
                    + vm.importosottoscrizionedecimali)
                  * 100,
                divisa: vm.divisa
              }
            }, calcolasottoscrizioneOK, calcolasottoscrizioneKO);
        } else {*/
        // call BE
        RisparmioBuoniServices
          .calcolaValoreBfp(
            {
              data: {
                dataEmissione: italian_date(vm.datasottoscrizione),
                dataRimborso: italian_date(vm.datarimoborsosottoscrizione),
                dataNascita: italian_date(vm.datarimoborsosottoscrizioneminore),
                tipoBuono: vm.tipologia,
                taglio: ""
                  + parseInt(vm.importosottoscrizione
                    + ","
                    + vm.importosottoscrizionedecimali)
                  * 100,
                divisa: vm.divisa
              }
            }, calcolasottoscrizioneOK, calcolasottoscrizioneKO);
      //}
    }



    vm.calcolasottoscrizioneAuto = function () {

      // // max 3 try
      // set_try_calcolo();
      // if (vm.activate_cookie_calcolo && vm.try_calcolo > 3) {
      // 	vm.show_max_calcolo = true;
      // 	vm.show_calcolo_buono = false;
      // 	go_to("#max_tentativi");
      // 	return;
      // }

      // show_pageloader();

      // call BE
      RisparmioBuoniServices
        .calcolaValoreBfp(
          {
            data: {
              dataEmissione: italian_date(vm.datasottoscrizione),
              dataRimborso: italian_date(vm.datarimoborsosottoscrizione),
              dataNascita: italian_date(vm.datarimoborsosottoscrizioneminore),
              tipoBuono: vm.tipologia,
              taglio: ""
                + parseInt(vm.importosottoscrizione
                  + ","
                  + vm.importosottoscrizionedecimali)
                * 100,
              divisa: vm.divisa
            }
          }, calcolasottoscrizioneOK, calcolasottoscrizioneKO);

    }

    /**
     * calcola valore bfp service OK
     */
    function calcolasottoscrizioneOK(httpResponse) {
      $log.log('ManagerController calcolaValoreBfp response:', httpResponse);

      // add BE data to valore buono
      vm.valorebuono = httpResponse.data || {};

      // show result
      vm.show_serviceerrorsottoscrizione = false;
      vm.show_calcolo_buono = true;
      vm.show_notevalore = true;
      // make_popovers();
      // hide_pageloader();
      // go_to("#valore_buono");
    }

    /**
     * calcola valore bfp service KO
     */
    function calcolasottoscrizioneKO(httpResponse) {
      $log.log('ManagerController calcolaValoreBfp error-response:',
        httpResponse);

      if (httpResponse.data && httpResponse.data.metadata) {
        vm.serviceerrorsottoscrizione_message = httpResponse.data.metadata.message;
      } else {
        vm.serviceerrorsottoscrizione_message = "Si è verificato un errore. Ci scusiamo per il disagio arrecato."
      }

      // show error box
      vm.show_serviceerrorsottoscrizione = true;
      vm.show_calcolo_buono = false;
      vm.show_notevalore = false;
      // hide_pageloader();
      // go_to("#service_error_sottoscrizione");
    }

    /**
     * get tipologia buono selezionata
     */
    vm.get_tipologia = function () {
      for (const option of (vm.tipologie_options || [])) {
        if (option.tipoBuono === vm.tipologia) {
          return option.descrizione
        }
      }
      return "-";
    }

    /**
     * get valore (no decimals)
     */
    vm.get_valore = function (value) {
      return italian_digits(Math.floor(value / 100));
    }

    /**
     * get valore (2 decimals)
     */
    vm.get_valore_decimal = function (value) {
      var n = value / 100;
      var d = (n - Math.floor(n)).toFixed(2);
      return d.split(".")[1];
    }

    /**
     * get try calcolo
     */
    function get_try_calcolo() {
      if (vm.activate_cookie_calcolo && typeof Cookies !== 'undefined') {
        var t = Cookies.get('7e6b312ca0f057dfe9173baa45db03b6');
        if (t && !isNaN(t)) {
          return parseInt(Cookies.get('7e6b312ca0f057dfe9173baa45db03b6'));
        }
      }
      return 0;
    }

    /**
     * set try calcolo
     */
    function set_try_calcolo() {
      vm.try_calcolo++;
      if (vm.activate_cookie_calcolo && typeof Cookies !== 'undefined') {
        Cookies.set("7e6b312ca0f057dfe9173baa45db03b6", vm.try_calcolo,
          {
            domain: ".poste.it",
            expires: 365
          });
      }
    }

    /** ********************************************************************* */
    /** UTILITIES *********************************************************** */
    /** ********************************************************************* */

    /**
     * clean page: reset all data
     */
    function reset() {
      // set tabs & app visibility
      // vm.tabs = (typeof tabs != "undefined") ? tabs : [];
      // vm.note = (typeof note != "undefined") ? note : "";
      // vm.durata_options = (typeof durate != "undefined") ? durate : "";
      vm.showAPP = true;

      // error boxes
      vm.show_boxerror = false;
      vm.show_boxerrorminori = false;
      vm.show_boxerrorsenior = false;
      vm.show_boxerrorfuturo = false;
      vm.show_serviceerror = false;
      vm.show_serviceerrorrimborso = false;
      vm.show_serviceerrorsottoscrizione = false;
      vm.show_serviceerrorsenior = false;
      vm.show_serviceerrorfuturobe = false;
      vm.serviceerror_message = "";
      vm.serviceerrorrimborso_message = "";
      vm.serviceerrorsottoscrizione_message = "";
      vm.serviceerrorsenior_message = "";

      // trova il buono + calcolo rimborso
      vm.show_importoerror = false;
      vm.show_rimborsograph = false;
      vm.disable_calcolo = true;
      vm.disable_calcolarimborso = true;
      vm.show_risultati = false;
      vm.show_confronto = false;
      vm.show_rimborso = false;
      vm.show_note = false;

      vm.importo = null;
      vm.durata = null;
      vm.buoni = null;
      vm.buoni_selected = null;
      vm.datarimborso = null;
      vm.noterimborso = null;

      // buono minori
      vm.show_minori = false;
      vm.show_noteminori = false;

      vm.importominori = null;
      vm.datanascitaminori = null;

      // buono senior
      vm.show_importoerrorsenior = false;
      vm.disable_calcolosenior = true;
      vm.show_senior = false;
      vm.show_notesenior = false;

      vm.importosenior = null;
      vm.datanascitasenior = null;
      vm.buono_senior = null;

      // buono futuro
      vm.show_notefuturo = false;

      vm.importofuturo = null;
      vm.datanascitafuturo = null;
      vm.buono_futuro = null;

      // calcolo sottoscrizioni
      vm.show_calcola = false;
      vm.show_calcolo_buono = false;
      vm.show_max_calcolo = false;
      vm.show_notevalore = false;
      vm.calcola_disabled = true;
      vm.sottoscrizione_disabled = true;
      vm.datasottoscrizione = null;
      vm.datarimoborsosottoscrizione = null;
      vm.datarimoborsosottoscrizioneminore = null;
      vm.importosottoscrizione = null;
      vm.importosottoscrizionedecimali = "00";
      vm.activate_cookie_calcolo = false;
      vm.try_calcolo = get_try_calcolo();

      vm.tipologia = null;
      vm.divisa = null;
      vm.divisa_disabled = false;
      vm.divisa_options = {
        "EUR": {
          label: 'Euro',
          value: 'EUR',
          symbol: '€',
          decimals: true
        },
        "ITL": {
          label: 'Lira',
          value: 'ITL',
          symbol: '₤',
          decimals: false
        }
      }
      vm.tipologie_options = null;
      vm.valorebuono = null;

      // $timeout(customSelect);
      return vm.showAPP;
    }

    /**
     * make a Chart.js graph
     */
    function make_graph(id, type, data, hide_x, min, max) {
      $timeout(function () {
        var ctx = document.getElementById(id);
        if (null != ctx) {
          ctx = ctx.getContext('2d');
          if (window["my_" + id]) {
            window["my_" + id].destroy();
          }
          window["my_" + id] = new Chart(
            ctx,
            {
              type: type,
              data: data,
              options: {
                scales: {
                  xAxes: [{
                    gridLines: {
                      display: vm.riceviCedole ? false : true, // Hide the y axis line and grid
                      drawBorder: vm.riceviCedole ? false : true // Hide the axis border line
                    },
                    ticks: {
                      autoSkip: true,
                      maxTicksLimit: 1,
                      maxRotation: 0,
                      minRotation: 0,
                      callback: function (value, index,
                        values) {
                        if (hide_x && index == 0){
                          if(index == 0 && values.length == 1){
                            return value;
                          } else {
                            return '';
                          }
                        }
                        return vm.riceviCedole ? value.split(' ')[1] + ' ' +  value.split(' ')[2]  : value;
                        }
                      }
                      }],
                  yAxes: [{
                    gridLines: {
                      drawBorder: vm.riceviCedole ? false : true // Hide the axis border line
                    },
                    ticks: {
                      beginAtZero: false,
                      callback: function (value, index, values) {
                      return vm.riceviCedole ? vm.get_digits(value) + ' €' : vm.get_digits(value);
                      },
                      autoSkip: true,
                      maxTicksLimit: 1,
                      min: min,
                      max: max
                    }
                  }]
                },
                responsive: true,
                legend: {
                  display: false
                },
                title: {
                  display: false
                },
                tooltips: vm.riceviCedole ? {
                  displayColors: false,
                  mode: 'nearest',
                  callbacks: {
                    // Prima riga del tooltip: la data formattata in italiano
                    title: function(tooltipItems, data) {
                      var date = tooltipItems[0].xLabel            
                      return 'Data:                ' + formatItalianDateString(date);
                    },
                    // Seconda riga del tooltip: valore netto formattato in euro
                    label: function(tooltipItem, data) {
                      var value = tooltipItem.yLabel; // valore netto
                      return 'Valore netto:                ' + value.toFixed(2).replace('.', ',') + ' €';
                    }
                  }
                } : {
                  mode: 'nearest',
                  callbacks: {
                    label: function (tooltipItem, data) {
                      var value = tooltipItem.yLabel;
                      var label = data.datasets[tooltipItem.datasetIndex].label
                        || '';
                      return label + " € "
                        + vm.get_digits(value);
                    }
                  }
                }
              }
            }
          );
        }
      });
    }

    /**
     * Checks if the input string has the format "DD monthName YYYY".
     * If not, tries to format it to that pattern.
     * @param {string} str
     * @returns {string}
     */
    function formatItalianDateString(str) {
      const mesiItaliani = [
        "Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno",
        "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"
      ];
      const regex = /^(\d{1,2})\s+([A-Za-z]+)\s+(\d{4})$/;
      if (regex.test(str)) {
        return str;
      }
      // Try to parse common formats: dd/mm/yyyy, yyyy-mm-dd, etc.
      let date;
      if (/^\d{2}\/\d{2}\/\d{4}$/.test(str)) {
        // dd/mm/yyyy
        const [day, month, year] = str.split('/');
        date = new Date(year, month - 1, day);
      } else if (/^\d{4}-\d{2}-\d{2}$/.test(str)) {
        // yyyy-mm-dd
        const [year, month, day] = str.split('-');
        date = new Date(year, month - 1, day);
      } else if (/^\d{2}\/\d{4}$/.test(str)) {
        // mm/yyyy
        const [month, year] = str.split('/');
        date = new Date(year, month - 1, 1);
      } else if (/^\d{4}-\d{2}$/.test(str)) {
        // yyyy-mm
        const [year, month] = str.split('-');
        date = new Date(year, month - 1, 1);
      } else {
        date = new Date(str);
      }
      if (isNaN(date.getTime())) {
        return str;
      }
      const giorno = date.getDate() ;
      const mese = mesiItaliani[date.getMonth()];
      const anno = date.getFullYear();
      return `${giorno} ${mese} ${anno}` ;
    }

    /**
     * make DatePicker.js calendars
     */
    function make_calendar(id, options) {
      $timeout(function () {
        $(id + ' input:not([readonly])').val("");
        $(id + ' input:not([readonly])')
          .datepicker(
            {
              format: 'dd/mm/yyyy',
              onRender: function (date) {
                if (options) {
                  if (options.startDate
                    && options.endDate) {
                    return (date.valueOf() < options.startDate || date
                      .valueOf() > options.endDate) ? 'disabled'
                      : '';
                  } else if (options.startDate) {
                    return date.valueOf() < options.startDate ? 'disabled'
                      : '';
                  } else if (options.endDate) {
                    return date.valueOf() > options.endDate ? 'disabled'
                      : '';
                  }
                }
              }
            }).on('changeDate', function (ev) {
              //$(id + " input:not([readonly])").datepicker('hide');
              $timeout(function () {
                $(ev.target).trigger('change');
              });
            });
        $(id + " .input-group-addon").click(function () {
          var calendar = $(this).prev();
          $(calendar).focus();
        });
      });
    }

    /**
     * make popovers
     */
    function make_popovers() {
      $timeout(function () {
        var template = '<div class="popover"><div class="arrow"></div>'
          + '<h3 class="popover-title"></h3><div class="popover-content"></div></div>';
        $('[data-toggle="popover"]').popover({
          html: true,
          template: template,
          placement: popoverwheretoplace
        });
        $('[data-toggle=popover]').on('click', function (e) {
          // $('[data-toggle=popover]').not(this).popover('hide');
        });
        $(window).resize();
      }, 2000);
    }

    /**
     * download file
     */
    function download_file(blob, filename) {
      if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, (filename || 'download'));
      } else {
        var url = URL.createObjectURL(blob);
        var a = document.createElement('a');
        a.href = url;
        a.download = filename || 'download';
        var clickHandler = function () {
          setTimeout(function () {
            URL.revokeObjectURL(url);
            this.removeEventListener('click', clickHandler);
          }, 150);
        };
        a.addEventListener('click', clickHandler, false);
        a.click();
        return a;
      }
    }

    /**
     * return Italian digits of value
     */
    function italian_digits(value) {
      return parseFloat(value).toLocaleString('it-IT', {
        /*
         * style : 'currency', currency : 'EUR',
         */
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      });
    }

    /**
     * return Italian digits of value with fraction
     */
    vm.get_digits = function (value) {
      return parseFloat(value).toLocaleString('it-IT', {
        /* style : 'currency', */
        /* currency : 'EUR', */
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    }

    vm.get_currency

    vm.get_value = function (value) {
      value = vm.get_digits(value);
      return value.split(',')
    }

    /**
     * update currency on inputs to Italian format
     */
    vm.update_importo = function (id, value, reverse) {
      if (!reverse && value) {
        $(id).val(italian_digits(value));
      } else {
        $(id).val(value || "");
      }
    }

    /**
     * return Italian date string of date from dd/mm/yyyy to yyyy-mm-dd
     */
    function italian_date(date) {
      if (date) {
        var d = date.split("/");
        var y = d.splice(-1)[0];
        var m = d.splice(-1)[0]
        d.splice(0, 0, m);
        d.splice(0, 0, y);
        return d.join("-");
      }
      return null;
    }

    /**
     * check if string is a valid date (dd/mm/yyyy)
     */
    function is_valid_date(s) {
      if (s) {
        var separators = ['\\.', '\\-', '\\/'];
        var bits = s.split(new RegExp(separators.join('|'), 'g'));
        var d = new Date(bits[2], bits[1] - 1, bits[0]);
        return d.getFullYear() == bits[2] && d.getMonth() + 1 == bits[1];
      }
      return false;
    }

    /**
     * get date object of string (from dd/mm/yyyy to yyyy-mm-dd)
     */
    function get_date(s) {
      if (is_valid_date(s)) {
        var selected = italian_date(s);
        if (selected) {
          return new Date(selected);
        }
      }
      return null;
    }

    /**
     * return reverse Italian date string of date from yyyy-mm-dd to dd/mm/yyyy
     */
    vm.italian_date_r = function (date) {
      if (date) {
        var d = date.split("-");
        var y = d.splice(-1)[0];
        var m = d.splice(-1)[0]
        d.splice(0, 0, m);
        d.splice(0, 0, y);
        return d.join("/");
      }
      return null;
    }

    /**
     * return full date from yyyy-mm-dd
     */
    vm.get_full_date = function (date) {
      if (date) {
        var d = date.split("/");
        var date = new Date(Date.UTC(d[2], d[1] - 1, d[0]));
        return date.toLocaleString('it-IT', {
          year: 'numeric',
          month: 'long',
          day: 'numeric'
        });
      }
      return "";
    }

    /**
     * trust HTML
     */
    vm.getHtml = function (html) {
      return $sce.trustAsHtml(html);
    }

    /**
     * go to #id
     */
    function go_to(id) {
      $timeout(function () {
        $([document.documentElement, document.body]).animate({
          scrollTop: $(id).offset().top
        });
      }, 100);
    }

    /**
     * check for hash and load it
     */
    function check_hash() {
      $timeout(function () {
        var hash = window.location.hash;
        var tabs = $("#tabs_selector li a");
        for (var i = 0; i < tabs.length; i++) {
          if ($(tabs[i]).attr("hashid") == hash.toLowerCase()) {
            $(tabs[i]).click();
          }
        }
        var options = $("#tabSelect option");
        for (var i = 0; i < options.length; i++) {
          if ($(options[i]).attr("hashid") == hash.toLowerCase()) {
            $("#tabSelect").val($(options[i]).val());
            // customSelect();
          }
        }
      });
    }

    /**
     * convert base64 to array buffer
     */
    function base64ToArrayBuffer(base64) {
      var binary_string = window.atob(base64);
      var len = binary_string.length;
      var bytes = new Uint8Array(len);
      for (var i = 0; i < len; i++) {
        bytes[i] = binary_string.charCodeAt(i);
      }
      return bytes.buffer;
    }

    /**
     * return singular or plural form of word
     */
    function decline(word, singular, plural) {
      return (word == 1) ? singular : plural;
    }

    /**
     * get current date without time
     */
    function get_currentDate() {
      var d = new Date();
      d.setHours(0, 0, 0, 0);
      return d.getTime();
    }

    /**
     * prevent default events
     * @param {*} e 
     */
    vm.preventDefault = function (e, noPropagation) {
      if (e) {
        e.preventDefault();
        if (noPropagation) {
          e.stopPropagation();
        }
      }
    }

  }

  /**
 * RisparmioBuoniServices CONTROLLER
 * 
 * @param $resource
 * @param $filter
 * @returns
 */
  function RisparmioBuoniServicesController($resource, $filter) {

    // generic parameters
    var requestMilliseconds = new Date().getTime();
    var dt = $filter('date')(new Date(), 'dd/MM/yyyy - HH:mm:ss');

    // services base url
    var url = '../../rpol/private/rest/:service/:api/:category/:action';

    // services
    return $resource(url, {}, {

      /**
       * catalogo BFP service
       */
      catalogoBfp: {
        method: 'POST',
        headers: {
          requestID: 'RPOL.WEB.' + requestMilliseconds,
          requestTimestamp: dt
        },
        params: {
          service: 'rpolSimulatore',
          action: 'catalogoBfp'
        }
      },

      /**
       * simula BFP service
       */
      simulaBfp: {
        method: 'POST',
        headers: {
          requestID: 'RPOL.WEB.' + requestMilliseconds,
          requestTimestamp: dt
        },
        params: {
          service: 'rpolSimulatore',
          api: 'simulatore',
          action: 'simulaBfp'
        }
      },
      /**
       * simula BFP Cedole service deprecato
       */
      // simulaBfpCedola: {
      //   method: 'POST',
      //   headers: {
      //     requestID: 'RPOL.WEB.' + requestMilliseconds,
      //     requestTimestamp: dt
      //   },
      //   params: {
      //     service: 'rpolSimulatore',
      //     api: 'simulatore',
      //     action: 'simulaBfpCedola'
      //   }
      // },

      buoniCedola: {
        method: 'GET',
        headers: {
          requestID: 'RPOL.WEB.' + requestMilliseconds,
          requestTimestamp: dt
        },
        params: {
          service: 'rpolSimulatore',
          api: 'simulatore',
          action: 'buoniCedola'
        }
      },

      /**
       * download data service
       */
      downloadData: {
        method: 'POST',
        headers: {
          requestID: 'RPOL.WEB.' + requestMilliseconds,
          requestTimestamp: dt
        },
        params: {
          service: 'rpolSimulatore',
          api: 'simulatore',
          action: 'downloadData'
        }
      },

      /**
       * download data cedola service
       */
      downloadDataCedola: {
        method: 'POST',
        headers: {
          requestID: 'RPOL.WEB.' + requestMilliseconds,
          requestTimestamp: dt
        },
        params: {
          service: 'rpolSimulatore',
          api: 'simulatore',
          action: 'downloadDataCedola'
        }
      },

      /**
       * download data service
       */
      downloadDataPdf: {
        method: 'POST',
        headers: {
          requestID: 'RPOL.WEB.' + requestMilliseconds,
          requestTimestamp: dt
        },
        params: {
          service: 'rpolSimulatore',
          api: 'simulatore',
          action: 'downloadDataPdf'
        }
      },

      /**
       * calcola rimborso buoni service
       */
      calcolaRimborso: {
        method: 'POST',
        headers: {
          requestID: 'RPOL.WEB.' + requestMilliseconds,
          requestTimestamp: dt
        },
        params: {
          service: 'rpolSimulatore',
          api: 'calcolatore',
          category: 'bfp',
          action: 'calcolaRimborso'
        }
      },

      /**
       * buono minori service
       */
      buonominori: {
        method: 'POST',
        headers: {
          requestID: 'RPOL.WEB.' + requestMilliseconds,
          requestTimestamp: dt
        },
        params: {
          service: 'rpolSimulatore',
          api: 'simulatore',
          action: 'buonominori'
        }
      },

      /**
       * buono senior service
       */
      buonosenior: {
        method: 'POST',
        headers: {
          requestID: 'RPOL.WEB.' + requestMilliseconds,
          requestTimestamp: dt
        },
        params: {
          service: 'rpolSimulatore',
          api: 'calcolatore',
          category: 'bfp',
          action: 'calcolaSenior'
        }
      },

      /**
       * buono futuro service
       */
      buonofuturo: {
        method: 'POST',
        headers: {
          requestID: 'RPOL.WEB.' + requestMilliseconds,
          requestTimestamp: dt,
          //testErrorResponseRPOL: "errore_datanascitafuturo",
        },
        params: {
          service: 'rpolSimulatore',
          api: 'calcolatore',
          category: 'bfp',
          action: 'calcolaFuturo'
        }
      },

      /**
       * calcola valore buono service
       */
      calcolaValoreBfp: {
        method: 'POST',
        headers: {
          requestID: 'RPOL.WEB.' + requestMilliseconds,
          requestTimestamp: dt
        },
        params: {
          service: 'rpolSimulatore',
          api: 'calcolatore',
          category: 'bfp',
          action: 'calcolaValoreBfp'
        }
      },
      /**
       * calcola valore buono cedole service
       */
      calcolaValoreBfpCedole: {
        method: 'POST',
        headers: {
          requestID: 'RPOL.WEB.' + requestMilliseconds,
          requestTimestamp: dt
        },
        params: {
          service: 'rpolSimulatore',
          api: 'calcolatore',
          category: 'bfp',
          action: 'calcolaValoreBfpCedole'
        }
      }

    });

  }
})();